import { Image } from "@unpic/react";
import LogoTrud from "../../../assets/images/logos/logo-trud.webp";

function LoadingScreenPage() {
  return (
    <div className="w-full h-full flex-1 bg-transparent flex justify-center items-center">
      <div className="w-[60px] h-[60px] relative">
        <div className="w-[60px] h-[60px] rounded-full border-[3px] border-[#ddd] border-t-brand-primary animate-spin" />
        <Image
          src={LogoTrud}
          alt="Loading..."
          width={24}
          height={24}
          className="w-[40%] h-auto absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      </div>
    </div>
  );
}

export default LoadingScreenPage;
